import React from 'react'
import { useLocation, Link } from 'react-router-dom'
import HeaderButton from './HeaderButton'
import Header from './Header'
import Footer from './Footer'

function Video() {

    const location = useLocation()
    const link = location?.state?.link
    const name = location?.state?.name

    const unsecuredCopyToClipboard = (text) => { const textArea = document.createElement("textarea"); textArea.value = text; document.body.appendChild(textArea); textArea.focus(); textArea.select(); try { document.execCommand('copy') } catch (err) { console.error('Unable to copy to clipboard', err) } document.body.removeChild(textArea) };

    /**
     * Copies the text passed as param to the system clipboard
     * Check if using HTTPS and navigator.clipboard is available
     * Then uses standard clipboard API, otherwise uses fallback
    */
    const copyToClipboard = (content) => {
        if (window.isSecureContext && navigator.clipboard) {
            navigator.clipboard.writeText(content);
        } else {
            unsecuredCopyToClipboard(content);
        }
    };

    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
            <Header />
            <Link to="/">
                <HeaderButton name={"Home"} />
            </Link>
            <main className="flex flex-col items-center justify-center flex-1 w-full px-4 relative">
                <video style={{ width: '1000px', height: '550px' }} controls autoPlay controlsList="nodownload" onContextMenu={() => { return false }}>
                    <source src={link} />
                </video>
                <p>{name}</p>
                <button
                    className='bg-slate-950 text-white p-16 py-1 px-3 rounded hover:bg-slate-700'
                    onClick={() => copyToClipboard(link)}>
                    Copy Stream url
                </button>
            </main>
            <Footer />
        </div>
    )
}


export default Video
